import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatadogRumService } from '../../../../services';

@Component({
  selector: 'job-screen-version-toggle',
  templateUrl: './job-screen-version-toggle.component.html',
  styleUrls: ['./job-screen-version-toggle.component.scss'],
})
export class JobScreenVersionToggleComponent implements OnInit {
  @Output() viewTypeChanged = new EventEmitter<number>();

  @Input() viewType: number;

  constructor(private datadogRumService: DatadogRumService) {}

  async ngOnInit() {}

  toggleView(event: any) {
    this.viewTypeChanged.emit(event.value);

    this.datadogRumService.addAction('supplier-job-screen-view-change', {
      viewType: event.value == 1 ? 'new' : 'old',
    });
  }
}
